import Background from '@passkeys/ui/background';
import type { ReactNode } from 'react';

import Frame from '@/ui/components/frame/index.js';
import Modal from '@/ui/components/modal/index.js';
import { cn } from '@/ui/utils/classnames';

type FramedLayoutProps = {
  children: ReactNode;
  className?: string;
  header?: ReactNode;
  scrollContainerClassName?: string;
};

function FixedLayout({
  children,
  header,
  className,
  scrollContainerClassName,
}: FramedLayoutProps) {
  const hasHeader = !!header;
  return (
    <Frame>
      <Background
        className={cn('overflow-hidden', hasHeader && '[--header-height:88px]')}
      >
        {hasHeader && <div className="h-[--header-height] px-6">{header}</div>}
        <div
          className={cn(
            'overflow-y-auto scrollbar-hide',
            hasHeader ? 'h-[calc(100%-var(--header-height))]' : 'h-full',
            scrollContainerClassName,
          )}
        >
          <main className={cn('px-6', className)}>{children}</main>
        </div>
        <Modal />
      </Background>
    </Frame>
  );
}

export default FixedLayout;
